(() => {
  // Both sections may load this asset. Install the shared listeners only once.
  if (window.jmMobileEdgeLoopInstalled) return;
  window.jmMobileEdgeLoopInstalled = true;
  const states = new WeakMap();
  function initialize(scope) {
    scope.querySelectorAll('[data-jm-mobile-loop]').forEach(root => {
      if (states.has(root)) return;
      const track = root.querySelector('.jm-scenes__track, [id^="Slider-"]');
      if (!track) return;
      const controller = new AbortController();
      const options = { signal: controller.signal, passive: true };
      let start = null;
      states.set(root, controller);
      track.addEventListener('touchstart', event => {
        start = null;
        if (!matchMedia('(max-width: 749px)').matches || event.touches.length !== 1) return;
        const max = track.scrollWidth - track.clientWidth;
        if (max < 2) return;
        const touch = event.touches[0];
        start = { x: touch.clientX, y: touch.clientY, first: track.scrollLeft <= 2, last: track.scrollLeft >= max - 2 };
      }, options);
      const destination = touch => {
        if (!start || !matchMedia('(max-width: 749px)').matches) return null;
        const dx = touch.clientX - start.x, dy = touch.clientY - start.y;
        if (Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy) * 1.2) return null;
        if (start.last && dx < 0) return 0;
        if (start.first && dx > 0) return track.scrollWidth - track.clientWidth;
        return null;
      };
      track.addEventListener('touchmove', event => {
        if (event.touches.length !== 1) { start = null; return; }
        if (destination(event.touches[0]) !== null && event.cancelable) event.preventDefault();
      }, { signal: controller.signal, passive: false });
      track.addEventListener('touchend', event => {
        const left = event.changedTouches.length === 1 ? destination(event.changedTouches[0]) : null;
        start = null;
        if (left === null) return;
        // Jump at the boundary, leaving native scrolling between ordinary cards intact.
        if (root.matches('jm-five-scenes') && typeof root.select === 'function') {
          root.select(left === 0 ? 0 : root.cards.length - 1, true);
        } else {
          if (root.setPositionTimeout) clearTimeout(root.setPositionTimeout);
          track.scrollTo({ left, behavior: 'instant' });
        }
        if (event.cancelable) event.preventDefault();
      }, { signal: controller.signal, passive: false });
      track.addEventListener('touchcancel', () => { start = null; }, options);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-jm-mobile-loop]').forEach(root => { states.get(root)?.abort(); states.delete(root); });
  });
})();
